import { render, staticRenderFns } from "./Inseminacion.vue?vue&type=template&id=304aeb30&scoped=true"
import script from "./Inseminacion.vue?vue&type=script&lang=js"
export * from "./Inseminacion.vue?vue&type=script&lang=js"
import style0 from "./Inseminacion.vue?vue&type=style&index=0&id=304aeb30&prod&scoped=true&lang=css"
import style1 from "./Inseminacion.vue?vue&type=style&index=1&id=304aeb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304aeb30",
  null
  
)

export default component.exports